'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionItem } from '@heroui/react';
import { LucideChevronDown } from 'lucide-react';
import { useMemo } from 'react';
import { InfiniteListDefaultEmptyList } from '@/components/infinite-list/components/default-empty-list';
import { InfiniteListDefaultErrorView } from '@/components/infinite-list/components/default-error-view';
import { InfiniteListDefaultLoader } from '@/components/infinite-list/components/default-loader';
import DefaultListFooter from '@/components/ui/default-list-footer';
import parseTextWithLinks from '@/shared/functions/parse-text-with-links';
import { useGetAllFaqs } from '@/shared/functions/tanstack-query/get/faqs/get-all-faqs/use-index';
import { useFaqsSearchParams } from '../../../../shared/functions/use-faqs-search-params';
import { FaqMedias } from '../faq-medias';
export default function FaqsList() {
  const $ = _c(20);
  const {
    page,
    setPage,
    debouncedSearch
  } = useFaqsSearchParams();
  let t0;
  if ($[0] !== debouncedSearch || $[1] !== page) {
    t0 = {
      search: debouncedSearch,
      page,
      quantity: 5,
      active: "true"
    };
    $[0] = debouncedSearch;
    $[1] = page;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data: Faqs,
    isLoading,
    error,
    refetch
  } = useGetAllFaqs(t0);
  let t1;
  bb0: {
    if (isLoading) {
      let t2;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <InfiniteListDefaultLoader />;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb0;
    }
    if (error) {
      let t2;
      if ($[4] !== error || $[5] !== refetch) {
        t2 = <InfiniteListDefaultErrorView error={error} retry={refetch} />;
        $[4] = error;
        $[5] = refetch;
        $[6] = t2;
      } else {
        t2 = $[6];
      }
      t1 = t2;
      break bb0;
    }
    if (!Faqs?.data?.length) {
      let t2;
      if ($[7] !== refetch) {
        t2 = <InfiniteListDefaultEmptyList retry={refetch} />;
        $[7] = refetch;
        $[8] = t2;
      } else {
        t2 = $[8];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[9] !== Faqs.data) {
      t2 = Faqs.data.length >= 1 ? Faqs.data.map(_temp) : <AccordionItem title="Sem Resultados" isDisabled={true} hasChildItems={false} />;
      $[9] = Faqs.data;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    let t3;
    if ($[11] !== t2) {
      t3 = <Accordion selectionMode="multiple" showDivider={false}>{t2}</Accordion>;
      $[11] = t2;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t1 = t3;
  }
  const renderContent = t1;
  const t2 = Faqs?.totalPages || 0;
  let t3;
  if ($[13] !== page || $[14] !== setPage || $[15] !== t2) {
    t3 = <DefaultListFooter className="bg-[#f5f5f5]" totalPages={t2} page={page} setPage={setPage} />;
    $[13] = page;
    $[14] = setPage;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== renderContent || $[18] !== t3) {
    t4 = <aside className="flex flex-col gap-6 min-h-0 h-full">{renderContent}{t3}</aside>;
    $[17] = renderContent;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function _temp(faq) {
  return <AccordionItem classNames={{
    trigger: "flex-row-reverse",
    title: "text-paragraph font-bold text-xl sm:text-2xl",
    base: " rounded-lg ",
    content: " text-lg whitespace-pre-wrap text-pretty",
    indicator: "data-[open=true]:-rotate-180"
  }} indicator={<LucideChevronDown size={28} className="text-paragraph stroke-1" />} key={faq.id} title={faq.question}>{parseTextWithLinks(faq.answer)}<FaqMedias medias={faq.medias} /></AccordionItem>;
}